const state = {
  subjects: [],
  isLoaded: false
}

export default state
